export default __webpack_public_path__ + "01365ad7535b8cee358c3743b3cf8e97.svg";